export const LatLong = {
    latitude: 44.79756319758155,
    longitude: 20.45259791285454,
    location: "11001 Savski Venac Urban Municipality, Resavska"
}